import React, { useState } from 'react'
import CouponLoader from '../CouponLoader';
import { Button, Tab, Tabs, styled } from '@mui/material';
import TabButton from './TabButton';
import SKUGroupTABContent from './SKUGroupTABContent';
import DoneIcon from '@mui/icons-material/Done';

const StyledTabs = styled((props: any) => (
    <Tabs
      {...props}
      TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
    />
  ))({
    '& .MuiTabs-indicator': {
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: 'transparent',
    },
    '& .MuiTabs-indicatorSpan': {
      display:'none'
    },
  });

  const StyledTab = styled((props: any) => (
    <Tab disableRipple {...props} />
  ))(({ theme }) => ({
    textTransform: 'none',
    marginRight: '10px',
    borderRadius:'5px',
    padding:'0 10px',
    height:'40px',
    minHeight:'20px',
    border:'1px solid lightgray',
    color:'gray',
    '&.Mui-selected': {
      border:'1px solid var(--coupon-dark-blue)',
      color:'var(--coupon-dark-blue)',
      background:'var(--coupon-light-blue)'
    },
    '&.Mui-focusVisible': {
      backgroundColor: 'rgba(100, 95, 228, 0.32)',
    },
  }));

/**
 * This component is resposible for showing Entites tabs and selector functionality
 * @param param0 
 * @returns 
 */
function SKUGroupCommonSelector({
    data,
    tabsList,
    loading=false,
    handleSave,
    handleChange,
    editMode = false,
    getTabContent,
    multiple= false,
    saveLoading = false,
}: {
    data: any,
    loading?:boolean,
    handleSave:()=>void,
    handleChange:(selectedItems:Array<string>,entityName:string)=>void
    tabsList: Array<string>,
    editMode?:boolean,
    getTabContent:(...args:any[])=>any,
    multiple?:boolean,
    saveLoading?:boolean
}) {
    const [currentTab, setCurrentTab] = useState<number>(0);
    
    const handleTabChange = (event: React.SyntheticEvent, newValue: number): void => {
        setCurrentTab(newValue);
    }

    const currentTabName:string = tabsList[currentTab] || "";

    const btnText = !editMode ? saveLoading ? 'Saving...':'Save': saveLoading?'Updating...':'Update';
    return (
        <div className='sku-group-single-selector-wrapper'>
            {
                loading ? <CouponLoader /> : <>
                    <div className="sku-group-selector-header">
                        <div className="sku-group-selector-selectors-wrapper">
                            <StyledTabs value={currentTab} onChange={handleTabChange} >
                                {
                                    tabsList?.map((name) => {
                                        const numberOfSelectedItems = data[name] ? Array.isArray(data[name])? data[name].length:1 : 0;
                                        return <StyledTab key={name} label={<TabButton text={name} numberOfSelectedItems={numberOfSelectedItems}/>} />
                                    })
                                }
                            </StyledTabs>
                        </div>
                        <div className="sku-group-selector-action-btn-wrapper">
                             <Button variant='contained' className='sku-group-save-btn' size='small' startIcon={<DoneIcon />} onClick={handleSave}>{btnText}</Button>
                        </div>
                    </div>
                    <div className='sku-group-selector-content'>
                        <SKUGroupTABContent
                            multiple={multiple}
                            getContent={getTabContent}
                            currentSelectedValues={data}
                            selectedOptions={data[currentTabName]} 
                            handleChange={handleChange}
                            currentTabName={currentTabName} 
                          />
                    </div>

                </>
            }
        </div>
    )
}

export default React.memo(SKUGroupCommonSelector);
